RivalIQ.apps.Admin.module('widgets', function (widgets, App, Backbone, Marionette, $, _, moment, plans) {

    'use strict';

    // NOTE must match values in the database table nbq_revenue_type
    const nbqRevenueTypeEnum = {
        1: 'RIQ organic',
        2: 'NBQ sold',
        3: 'NBQ sold, RIQ credit'
    };

    widgets.InvoiceCreateEdit = RivalIQ.views.ItemView.extend({
        template: '#invoiceCreateEditTemplate',

        ui: {
            modal: '.modal',
            title: '.modal-title',
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'onSave'
        },

        behaviors: {
            FormValidator: {},
            AttributeBuilder: {}
        },

        templateHelpers: function () {

            const me = this;

            const invoice_period_start = me.model.get('invoice_period_start');
            const startDate = (invoice_period_start ? moment.utc(invoice_period_start) : moment.utc());

            const invoice_period_end = me.model.get('invoice_period_end');
            const endDate = (invoice_period_end ? moment.utc(invoice_period_end) : moment.utc().add(1, 'year'));

            const groupedPlans = _.reduce(plans, function (memo, plan) {
                memo[(plan.legacy ? 'legacy' : 'current')].unshift(plan);
                return memo;
            }, {
                legacy: [],
                current: []
            });

            return {
                nbqRevenueTypeEnum: nbqRevenueTypeEnum,
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
                invoice_monthly_revenue: me.model.get('invoice_monthly_revenue') || '',
                invoice_total: me.model.get('invoice_total') || '',
                invoice_tax: me.model.get('invoice_tax') || '',
                plan_id: me.model.get('plan_id') || '',
                revenue_type: me.model.get('revenue_type') || '',
                nbq_revenue_type_id: me.model.get('nbq_revenue_type_id') || '',
                invoice_notes: me.model.get('invoice_notes') || '',
                plans: groupedPlans,
                action: (me.isCreate ? 'Create' : 'Edit')
            };
        },

        initialize: function () {

            const me = this;

            // track create vs. update for later
            me.isCreate = !me.model.get('id');
        },

        loadData: function () {

            // NOTE this is all here to get a reference to the collection, so we can add the new invoice to it later

            const me = this;
            const accountId = me.model.get('account_id');

            return RivalIQ.data.adminInvoices.fetch(accountId)
                .then(function (invoices) {
                    me.collection = invoices;
                });
        },

        onSave: function () {

            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            const result = me.model.save(me.model.serialize());

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {

                    if (me.isCreate) {
                        me.collection.add(me.model);
                        RivalIQ.execute('alert:info', 'Invoice Created.');
                    } else {
                        RivalIQ.execute('alert:info', 'Invoice Updated.');
                    }

                    RivalIQ.execute('hide:modal');
                })
                .fail(function () {

                    me.ui.saveBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again.');
                });
        }
    });


    const InvoiceDelete = Marionette.ItemView.extend({

        template: '#invoiceDeleteTemplate',

        ui: {
            modal: '.modal',
            save: '.x-save'
        },

        events: {
            'click @ui.save': 'onSave'
        },

        onSave: function () {
            const me = this;
            me.ui.save.button('loading');

            me.model.destroy()
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', 'Invoice Deleted.');
                })
                .fail(function () {
                    me.ui.save.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again.');
                });
        }
    });

    const Dropdown = Marionette.ItemView.extend({

        tagName: 'td',

        template: '#invoicesDropdownCellTemplate',

        events: {
            'click .x-edit': 'onEdit',
            'click .x-delete': 'onDelete'
        },

        onEdit: function () {

            const me = this;

            RivalIQ.execute('show:modal', new widgets.InvoiceCreateEdit({
                model: me.model.get('data')
            }));
        },

        onDelete: function () {

            const me = this;

            RivalIQ.execute('show:modal', new InvoiceDelete({
                model: me.model.get('data')
            }));
        }

    });

    const tableConfig = {
        className: 'table',
        rowClass: function (model) {
            // NOTE highlight rows in various important states
            return (model.get('is_upcoming') ? 'table-bg-aqua' : (model.isPastDue() ? 'table-bg-red' : ''));
        },
        columns: [
            {
                name: 'Record Id',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return model.get('id');
                }
            },
            {
                name: 'Period Start',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return moment.utc(model.get('invoice_period_start')).format('L');
                }
            },
            {
                name: 'Period End',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return moment.utc(model.get('invoice_period_end')).format('L');
                }
            },
            {
                name: 'MRR',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return `$${model.get('invoice_monthly_revenue')}`;
                }
            },
            {
                name: 'Invoice Total',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return `$${model.get('invoice_total')}`;
                }
            },
            {
                name: 'Sales Tax',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return `$${model.get('invoice_tax')}`;
                }
            },
            {
                name: 'Zip Code',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return _.get(model.get('tax_details'), 'zipCode');
                }
            },
            {
                name: 'Invoice Plan',
                cellClassName: 'cell-middle',
                value: function (model) {
                    const planId = model.get('plan_id');
                    if (planId) {
                        const plan = _.find(plans, {
                            id: planId
                        });
                        return plan.stripe_id;
                    } else {
                        return '--';
                    }
                }
            },
            {
                name: 'Revenue Type',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return model.get('revenue_type');
                }
            },
            {
                name: 'NBQ Revenue Type',
                cellClassName: 'cell-middle',
                value: function (model) {
                    const nbqRevTypeId = model.get('nbq_revenue_type_id');
                    return nbqRevenueTypeEnum[nbqRevTypeId];
                }
            },
            {
                name: 'Source',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return (model.get('is_stripe') ? 'Stripe' : 'Manual');
                }
            },
            {
                name: 'Stripe Upcoming?',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return (model.get('is_upcoming') ? 'Yes' : 'No');
                }
            },
            {
                name: 'Stripe Past Due?',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return (model.isPastDue() ? 'Yes' : 'No');
                }
            },
            {
                name: 'Notes',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return model.get('invoice_notes');
                }
            },
            {
                name: 'Actions',
                cellClassName: 'cell-middle',
                cellView: Dropdown
            }
        ]
    };

    const Invoices = widgets.Invoices = RivalIQ.views.LoadingTableView.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        config: tableConfig,

        loadData: function (callback) {

            const me = this;
            const accountId = me.getProp('accountId');

            const accountModel = new RivalIQ.apps.Admin.models.Account({
                id: accountId
            });

            $.when(RivalIQ.data.adminInvoices.fetch(accountId),
                accountModel.fetch())
                .done(function (invoices) {

                    // NOTE put our data where TableContainer expects it
                    me.model = new Backbone.Model({
                        data: invoices
                    });

                    // listen for change/add/delete
                    me.listenTo(invoices, 'sync', me.render);
                    me.listenTo(invoices, 'add', me.onRenderLoaded);
                    me.listenTo(invoices, 'remove', me.render);

                    me.setProps('owner_email', accountModel.get('owner_email'));
                    me.setProps('effectiveTaxRate', accountModel.get('effectiveTaxRate'));

                    callback();
                });
        }

    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const InvoicesWidget = Widget.extend({
        exportFormats: [],
        view: Invoices,
        getTitle: function () {
            const me = this;
            let title = '';
            if (me.getProp('owner_email')) {
                title = `Invoices for ${me.getProp('owner_email')} (effective tax rate: ${me.getProp('effectiveTaxRate')}%)`;
            }
            return title;
        },
        hasViewMore: _.constant(false)
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INVOICES, InvoicesWidget);

}, window.moment, window.plans);
